import React, { Component } from 'react'

export default class UploadBtn extends Component {

    render() {
        const { marginTop, value, name, onChange, filename } = this.props
        return (
            <div className="file has-name is-right" style={{ marginTop }} >
                <label className="file-label">
                    <input className="file-input" type="file" name={name} onChange={onChange} />
                    <span className="file-cta">
                        <span className="file-icon">
                            <img src={require('../../assets/icon/upload.png')} alt='upload' />
                        </span>
                        <span className="file-label">อัพโหลดเอกสาร</span>
                    </span>
                    <span className="file-name">
                        {filename} </span>
                </label>
            </div>
        )
    }
}





// WEBPACK FOOTER //
// ./src/components/Regular/UploadBtn.js